import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/graphic/play.svg'


const _withScopeId = n => (_pushScopeId("data-v-af2163ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "caseItem-photo" }
const _hoisted_2 = { class: "photo-box-wrap" }
const _hoisted_3 = { class: "photo-box-1" }
const _hoisted_4 = {
  key: 0,
  class: "video-player--play",
  src: _imports_0,
  alt: "play icon"
}
const _hoisted_5 = { class: "photo-box-2" }
const _hoisted_6 = { class: "photo-box-2-top" }
const _hoisted_7 = {
  key: 0,
  class: "video-player--play",
  src: _imports_0,
  alt: "play icon"
}
const _hoisted_8 = { class: "photo-box-2-bottom" }
const _hoisted_9 = {
  key: 0,
  class: "video-player--play",
  src: _imports_0,
  alt: "play icon"
}
const _hoisted_10 = {
  key: 0,
  class: "icon icon-users caseItem-shared"
}
const _hoisted_11 = {
  key: 0,
  class: "icon icon-users caseItem-shared"
}
const _hoisted_12 = {
  key: 1,
  class: "reshare-indicator"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-share" }, null, -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = {
  key: 0,
  class: "caseItem-author"
}
const _hoisted_16 = { class: "item-wrapper" }
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = {
  key: 0,
  class: "item-author-info"
}
const _hoisted_19 = {
  key: 0,
  class: "name"
}
const _hoisted_20 = ["src"]
const _hoisted_21 = {
  key: 1,
  class: "selector"
}
const _hoisted_22 = {
  key: 0,
  class: "checker checked"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-check" }, null, -1))
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = {
  key: 1,
  class: "checker unchecked"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton_item = _resolveComponent("el-skeleton-item")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_app_lazy_image = _resolveComponent("app-lazy-image")!
  const _component_mixed_case_settings_pop_up = _resolveComponent("mixed-case-settings-pop-up")!
  const _component_app_question_pop_up = _resolveComponent("app-question-pop-up")!
  const _component_move_to_pop_up = _resolveComponent("move-to-pop-up")!
  const _component_app_rename_case = _resolveComponent("app-rename-case")!
  const _component_share_pop_up = _resolveComponent("share-pop-up")!

  return (_openBlock(), _createElementBlock("div", {
    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.selectCase(_ctx.iCase))),
    class: _normalizeClass(["caseItem", { 'case-item-column': _ctx.columnView, 'case-item-selector': _ctx.selector}])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.getCasePhoto(_ctx.caseMedia[0]))
            ? (_openBlock(), _createBlock(_component_app_lazy_image, {
                url: _ctx.getCasePhoto(_ctx.caseMedia[0])?.url,
                class: _normalizeClass(_ctx.getCasePhoto(_ctx.caseMedia[0])?.class),
                key: _ctx.getCasePhoto(_ctx.caseMedia[0])?.url
              }, {
                loading: _withCtx(() => [
                  _createVNode(_component_el_skeleton, {
                    class: "fullsize",
                    animated: "",
                    style: {"--el-skeleton-color":"#AFBEC7"}
                  }, {
                    template: _withCtx(() => [
                      _createVNode(_component_el_skeleton_item, {
                        variant: "rect",
                        class: "fullsize"
                      })
                    ]),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createElementVNode("template", null, [
                    (_ctx.getCasePhoto(_ctx.caseMedia[0])?.isVideo)
                      ? (_openBlock(), _createElementBlock("img", _hoisted_4))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }, 8, ["url", "class"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            (_ctx.getCasePhoto(_ctx.caseMedia[1]))
              ? (_openBlock(), _createBlock(_component_app_lazy_image, {
                  url: _ctx.getCasePhoto(_ctx.caseMedia[1])?.url,
                  class: _normalizeClass(_ctx.getCasePhoto(_ctx.caseMedia[1])?.class),
                  key: _ctx.getCasePhoto(_ctx.caseMedia[1])?.url
                }, {
                  loading: _withCtx(() => [
                    _createVNode(_component_el_skeleton, {
                      class: "fullsize",
                      animated: "",
                      style: {"--el-skeleton-color":"#8D9EA8"}
                    }, {
                      template: _withCtx(() => [
                        _createVNode(_component_el_skeleton_item, {
                          variant: "rect",
                          class: "fullsize"
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("template", null, [
                      (_ctx.getCasePhoto(_ctx.caseMedia[1])?.isVideo)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_7))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }, 8, ["url", "class"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_8, [
            (_ctx.getCasePhoto(_ctx.caseMedia[2]))
              ? (_openBlock(), _createBlock(_component_app_lazy_image, {
                  url: _ctx.getCasePhoto(_ctx.caseMedia[2])?.url,
                  class: _normalizeClass(_ctx.getCasePhoto(_ctx.caseMedia[2])?.class),
                  key: _ctx.getCasePhoto(_ctx.caseMedia[2])?.url
                }, {
                  loading: _withCtx(() => [
                    _createVNode(_component_el_skeleton, {
                      class: "fullsize",
                      animated: "",
                      style: {"--el-skeleton-color":"#6C7D87"}
                    }, {
                      template: _withCtx(() => [
                        _createVNode(_component_el_skeleton_item, {
                          variant: "rect",
                          class: "fullsize"
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("template", null, [
                      (_ctx.getCasePhoto(_ctx.caseMedia[2])?.isVideo)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_9))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }, 8, ["url", "class"]))
              : _createCommentVNode("", true)
          ]),
          (!!_ctx.iCase.share && !_ctx.columnView && _ctx.myCase)
            ? (_openBlock(), _createElementBlock("i", _hoisted_10))
            : _createCommentVNode("", true)
        ])
      ]),
      (!!_ctx.iCase.share && _ctx.columnView && !_ctx.isNetwork)
        ? (_openBlock(), _createElementBlock("i", _hoisted_11))
        : _createCommentVNode("", true),
      (_ctx.reshareAllowed)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
        : _createCommentVNode("", true)
    ]),
    (!_ctx.hideTitle)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("h6", {
              class: "text",
              innerHTML: _ctx.descriptionWithLink(_ctx.iCase.title)
            }, null, 8, _hoisted_17),
            (_ctx.isNetwork)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  (_ctx.columnView && !_ctx.mainStore.isMobile)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(_ctx.authorName), 1))
                    : _createCommentVNode("", true),
                  (_ctx.photoUrl)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        class: "photo",
                        src: _ctx.photoUrl
                      }, null, 8, _hoisted_20))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.columnView && !_ctx.driveStore.isCaseSelector)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.isCaseSettingsPopUp = true), ["prevent","stop"])),
                class: "icon icon-dots case-item-option"
              }))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.selector)
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
          (_ctx.iCase.selected)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, _hoisted_24))
            : (_openBlock(), _createElementBlock("div", _hoisted_25))
        ]))
      : _createCommentVNode("", true),
    (_ctx.isCaseSettingsPopUp)
      ? (_openBlock(), _createBlock(_component_mixed_case_settings_pop_up, {
          key: 2,
          "i-case": _ctx.iCase,
          onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isCaseSettingsPopUp = false)),
          onOpenMovePopUp: _ctx.openMovePopUp,
          onDeleteCase: _ctx.openQuestionPopUp,
          onSaveCaseAsCopy: _ctx.saveCaseAsCopy,
          onRemoveSharing: _ctx.removeCaseFromSharing,
          onOpenRenamePopUp: _ctx.openRenamePopUp,
          onOnShare: _ctx.onShare
        }, null, 8, ["i-case", "onOpenMovePopUp", "onDeleteCase", "onSaveCaseAsCopy", "onRemoveSharing", "onOpenRenamePopUp", "onOnShare"]))
      : _createCommentVNode("", true),
    (_ctx.isQuestionPopUp)
      ? (_openBlock(), _createBlock(_component_app_question_pop_up, {
          key: 3,
          onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isQuestionPopUp = false)),
          onDelete: _ctx.deleteCase
        }, null, 8, ["onDelete"]))
      : _createCommentVNode("", true),
    (_ctx.isMoveToCasePopUp)
      ? (_openBlock(), _createBlock(_component_move_to_pop_up, {
          key: 4,
          class: "move-to-popup",
          item: _ctx.iCase!,
          "item-type": _ctx.SHARE_TYPES.CASE,
          onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isMoveToCasePopUp = false)),
          onUpdateLocation: _ctx.updateLocation
        }, null, 8, ["item", "item-type", "onUpdateLocation"]))
      : _createCommentVNode("", true),
    (_ctx.caseRenamePopUp)
      ? (_openBlock(), _createBlock(_component_app_rename_case, {
          key: 5,
          iCase: _ctx.iCase,
          onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.caseRenamePopUp = false))
        }, null, 8, ["iCase"]))
      : _createCommentVNode("", true),
    (_ctx.isSharePopUp)
      ? (_openBlock(), _createBlock(_component_share_pop_up, {
          key: 6,
          item: _ctx.iCase!,
          "item-type": _ctx.SHARE_TYPES.CASE,
          onOnShareByMessage: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('on-close'))),
          class: "share-popup",
          onHide: _ctx.onSharePopupHide,
          onClick: _withModifiers(_ctx.onSharePopupHide, ["stop"])
        }, null, 8, ["item", "item-type", "onHide", "onClick"]))
      : _createCommentVNode("", true)
  ], 2))
}